import { useNavigation } from '@react-navigation/native';
import { Button, Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import AccountContext from 'context/AccountContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnWithMargins, StyledWrapper } from 'styles/ContainerStyles';
import { RootNavProps } from 'types/navigation';
import { truncateText } from 'utils/commonUtils';
import {
  getCardMaskedLastNums,
  getDefaultPaymentOption,
} from 'utils/paymentUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import { useUiStore } from 'stores/uiStore';

const SettingIconComponent = () => (
  <Icon name="Settings-Filled-Gray" color={theme.colors.gray300} />
);

const AnprPaymentMethodModalContent = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<RootNavProps>();
  const {
    customer: { paymentCards, paymentOptions },
  } = useContext(AccountContext);
  const defaultPaymentOption = getDefaultPaymentOption(
    paymentOptions,
    paymentCards
  );
  // Fall back to card.isDefault for accounts without paymentOptions yet
  const defaultCard =
    defaultPaymentOption?.card ??
    paymentCards?.find((c) => c?.isDefault) ??
    null;
  const cardText =
    defaultPaymentOption?.paymentOption.method === 'MOBILEPAY'
      ? t('paymentMethods.mobilePay')
      : `${defaultCard?.type} ${truncateText(
          defaultCard?.description ?? '',
          15
        )} ${getCardMaskedLastNums(defaultCard)}`;

  const closeModal = () => useUiStore.getState().setSheetModal('');

  const handleConfirmCancel = () => {
    closeModal();
  };

  const navigateToAccount = () => {
    closeModal();
    navigate('mainTabs', {
      screen: 'accountScreen',
      params: { screen: 'myPaymentMethods' },
    });
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper mb={10} center testID="anprPaymentInfoDetail-description">
        <Meta center color={theme.colors.gray300}>
          {t('parking.anprPaymentInfoDetail', { cardNumber: cardText })}
        </Meta>
        <StyledWrapper
          mt={10}
          center
          testID="anprPaymentInfoDetail-description">
          <Meta center color={theme.colors.gray300}>
            {t('parking.anprPaymentInfoDetailInstruction')}
          </Meta>
        </StyledWrapper>
      </StyledWrapper>
      <ColumnWithMargins mb={10} key={'button.text'}>
        <Button
          testID="button-cancel"
          text={t('button.close')}
          size="l"
          buttonType="secondary"
          onPress={handleConfirmCancel}
        />
      </ColumnWithMargins>
      <Button
        {...testIdentifiers('button-go-to-payment')}
        text={t('button.goToPayment')}
        size="l"
        buttonType={'tertiary'}
        iconComponent={SettingIconComponent}
        onPress={navigateToAccount}
        iconRight
      />
    </StyledWrapper>
  );
};

export default AnprPaymentMethodModalContent;
